import { Dispatch } from "redux";
import { SETCHANGE_SELECTMEALITEM1, SETCHANGE_SELECTMEALITEM2, SETMEALCUSTOMIZEDATA } from "../redux/features/MealData";

export function ClearCustomizeMealItem(disPatch: Dispatch) {
    disPatch(SETCHANGE_SELECTMEALITEM1(''));
    disPatch(SETCHANGE_SELECTMEALITEM2(''));
    disPatch(SETMEALCUSTOMIZEDATA(''));
}

// @@  check is mealitem is  customoze
export function CheckMealItemIsCustomize(item: any) {
    return item?.item_step?.length > 0 || item?.step_sub_category_data?.length > 0
}